import axiosInstance from "../config/axios";
import API_ENDPOINTS from "../config/endpoints";

// Contact Service - Submit contact form
export const submitContactForm = async (contactData) => {
  try {
    const payload = {
      name: contactData.name,
      email: contactData.email,
      contact_number: contactData.contactNumber,
      subject: contactData.subject,
      message: contactData.message,
      recaptcha_token: contactData.recaptcha_token || contactData.recaptchaToken // Include reCAPTCHA token for backend verification
    };
    
    const response = await axiosInstance.post(API_ENDPOINTS.CONTACT_US, payload);
    return response;
  } catch (error) {
    throw error; // Centralized handler formats the error
  }
};

export default {
  submitContactForm
};